export const getTypography = (tokens: any) => {
  // Define your preferred font families here
  const FONT_FAMILIES = {
    display: "'SF Pro Display', 'Roboto', sans-serif",
    headline: "'SF Pro Display','Roboto', sans-serif",
    title: "'SF Pro Display','Roboto', sans-serif",
    body: "'SF Pro Display','Roboto', sans-serif",
    label: "'SF Pro Display','Roboto', sans-serif",
  };

  const currentTypography = tokens?.typography || {};

  const getSafeFont = (section: any, size: string) => {
    if (!section || !section[size]) return null;
    const data = section[size];
    return {
      fontSize: data.fontSize ? `${data.fontSize / 16}rem` : undefined,
      textDecoration: data.textDecoration,
      fontWeight: data.fontWeight,
      fontStyle: data.fontStyle,
      fontStretch: data.fontStretch,
      letterSpacing: data.letterSpacing,
      paragraphIndent: data.paragraphIndent,
      paragraphSpacing: data.paragraphSpacing,
      textCase: data.textCase,
      fontFamily:
        data.fontFamily || FONT_FAMILIES[section as keyof typeof FONT_FAMILIES],
    };
  };

  const typography: any = {
    fontFamily: FONT_FAMILIES.display,
    // Additional global typography settings if needed
  };

  // Map categories to your desired output keys
  const mappings = [
    { section: "display", sizes: ["large", "medium", "small"] },
    {
      section: "headline",
      sizes: ["large", "medium", "small"],
      prefix: "heading",
    },
    { section: "title", sizes: ["large", "medium", "small"] },
    { section: "body", sizes: ["large", "medium", "small"] },
    { section: "label", sizes: ["large", "medium", "small"] },
  ];

  mappings.forEach(({ section, sizes, prefix }) => {
    const sec = currentTypography[section];
    if (!sec) return;

    sizes.forEach((size) => {
      const key =
        (prefix || section) + size.charAt(0).toUpperCase() + size.slice(1); // e.g. displayLarge
      const value = getSafeFont(sec, size);
      if (value) {
        typography[key] = value;
      }
    });
  });

  return typography;
};
